import { connect } from 'react-redux';

import Actions from '../../Actions/Creators';
import DialogRequestAppointment from './Component/DialogRequestAppointment';


const mapStateToProps = (state, ownProps) => ({
    dialogState: state.requestAppointment,

    partnersList: state.metaData.partnersList,
    countryList: state.metaData.countryList,
    stateList: state.metaData.stateList,
    cityList: state.metaData.cityList,
    specialityList: state.metaData.specialityList,

    user: state.auth.userProfile,
    child: state.child.childList[state.child.selectedChild]
});


const mapDispatchToProps = (dispatch) => ({
    fetchCountryList: () => dispatch(Actions.fetchCountryList()),
    fetchStateList: (countryId) => dispatch(Actions.fetchStateList(countryId)),
    fetchCityList: (stateId) => dispatch(Actions.fetchCityList(stateId)),
    fetchPartnerList: () => dispatch(Actions.fetchPartnerList()),
    fetchSpecialityList: () => dispatch(Actions.fetchSpecialityList()),

    dropdownSelect: (id, index) => dispatch(Actions.draDropdownSelect(id, index)),
    changeRequest: (request) => dispatch(Actions.draChangeRequest(request)),

    resetStoreState: () => dispatch(Actions.resetAppointmentRequest()),
    postAppointmentRequest: (params) => dispatch(Actions.postAppointmentRequest(params))
});


export default connect(mapStateToProps, mapDispatchToProps)(DialogRequestAppointment)